export const MSG_LIST_ERROR = 'Error al consultar el historial';
export const MSG_DELETE_ORDER = '¿Desea eliminar el pedido? esta acción no puede ser revertida';
export const MSG_DELETE_ORDER_OK = 'Pedido eliminado correctamente';
export const MSG_DELETE_ORDER_ERROR = 'Error al eliminar el pedido';
